import { UseActiveOnScroll } from "../../hooks/useActiveOnScroll";
import styles from "./About.module.css";

import Button from "../../components/Button/Button";

const About = () => {
  const { observerRef: sectionRef, isVisible } = UseActiveOnScroll(0.3);

  return (
    <section
      className={`${styles.About} ${isVisible ? "active" : ""}`}
      name="About"
      ref={sectionRef}
    >
      <h1 className="section-header" style={{ "--x": "5%", "--y": "0rem" }}>
        About
      </h1>

      <div className={styles.content}>
        <ul>
  <li>
    💼 Currently an Software Engineer (Backend & Automation) at Arive Inc., designing and building scalable Node.js frameworks and Workflows, leveraging PostgreSQL and TypeScript to optimize performance, reliability, and maintainability.
  </li>
  <li>
    🎓 Completed Bachelor's in Computer Science Engineering.
  </li>
  <li>
    💻 Full Stack Developer with proficient knowledge of
    HTML, CSS, JavaScript, TypeScript, React, Node.js, MongoDB, PostgreSQL,
    and the MERN stack.
  </li>
  <li>
    🌐 Passionate about building responsive and scalable web applications.
  </li>
  <li>
    🧑‍💻 Completed three internships in the software development domain.
  </li>
  <li>
    ☁️ Achieved Milestone 3 in the Google Cloud Ready Facilitator Program.
  </li>
  <li>
    🧠 Strong foundation in Data Structures and Algorithms.
  </li>
  <li>
    🧩 Solved over 1000+ coding problems across various platforms.
  </li>
  <li>
    🏆 Active Competitive Programmer with good ratings on platforms like
    CodeChef and Codeforces.
  </li>
  <li>
    ⭐ Achieved 5★ on CodeChef and Specialist rank on Codeforces.
  </li>
</ul>


        <Button link={"mailto:2021002287.shivansh@ug.sharda.ac.in"}>
          Email
        </Button>
        {/* <Button link={"https://drive.google.com/file/d/1KS7dG5hQU-YlEGq0WdojvjeRWRw3CDl6/view?usp=sharing"}>Resume</Button> */}
      </div>
    </section>
  );
};

export { About };
